import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Routes from '@/modules/routes';
import Icon from '@/components/ui/Icon';
import SPAButton from '../../shared/SPAButton';
import SPADropdown from '../../shared/SPADropdown';

interface AddLessonsMenuProps {
  programId: number;
}

// "Add Lessons" is a dropdown with two paths, as "Add Program" is on the programs page:
// "Create new" goes straight to the legacy lesson form, "Reuse" opens the routed reuse dialog.
const AddLessonsMenu = ({ programId }: AddLessonsMenuProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <SPADropdown open={open} onOpenChange={setOpen}>
      <SPADropdown.Trigger asChild>
        <SPAButton variant="primary">
          Add Lessons
          <Icon icon="ChevronDown" size={12} />
        </SPAButton>
      </SPADropdown.Trigger>
      <SPADropdown.Content className="tw-w-56">
        <SPADropdown.Item asChild>
          <a href={Routes.new_admin_program_lesson_path(programId)}>Create new lesson</a>
        </SPADropdown.Item>
        {/* Radix closes the menu itself after onSelect. */}
        <SPADropdown.Item onSelect={() => navigate('reuse-lessons')}>
          Reuse from another program
        </SPADropdown.Item>
      </SPADropdown.Content>
    </SPADropdown>
  );
};

export default AddLessonsMenu;
